<div class="qr-page" [nbSpinner]="loading()">

  <wr-qr-code-building-header active="repairTasks"></wr-qr-code-building-header>

  <div class="toolbar">
    @if (!context.isExternal()) {
      <label class="finisher">
        <span class="finisher-label">Ihr Name (optional)</span>
        <input nbInput fullWidth size="small"
               data-cy="qr-repair-task-finisher-name"
               [maxLength]="finisherNameMaxLength"
               placeholder="Wird beim Abschließen vermerkt"
               [value]="finisherName()"
               (input)="updateFinisherName($any($event.target).value)">
      </label>
    }
    <nb-checkbox data-cy="qr-repair-task-only-section"
                 [checked]="onlyThisSection()"
                 (checkedChange)="onlyThisSection.set($event)">
      Nur diese Hausnummer ({{ sectionTaskCount() }})
    </nb-checkbox>
  </div>

  @if (repairTasks(); as tasks) {
    <div class="task-list" data-cy="qr-repair-task-list">
      @for (task of visibleRepairTasks(); track task.id) {
        <article class="task-card"
                 data-cy="qr-repair-task-card"
                 [attr.data-task-id]="task.id"
                 [class.task-card--overdue]="isOverdue(task)">
          <div class="task-top">
            <wr-repair-task-status-text [status]="task.status"></wr-repair-task-status-text>
            @if (inSelectedSection(task)) {
              <span class="task-here">
                <nb-icon icon="pin-outline" pack="eva"></nb-icon>
                Diese Hausnummer
              </span>
            }
          </div>

          <h3 class="task-title">{{ task.title }}</h3>

          <dl class="task-facts">
            @if (task.sectionText) {
              <dt>Adresse</dt>
              <dd>{{ task.sectionText }}</dd>
            }
            @if (task.checkpointName) {
              <dt>Prüfpunkt</dt>
              <dd>{{ task.checkpointName }}</dd>
            }
            @if (task.actionName) {
              <dt>Maßnahme</dt>
              <dd>{{ task.actionName }}</dd>
            }
            @if (task.note) {
              <dt>Feststellung</dt>
              <dd class="multiline">{{ task.note }}</dd>
            }
            @if (task.equipmentName) {
              <dt>TGA</dt>
              <dd>{{ task.equipmentName }}</dd>
            }
            @if (task.deadline) {
              <dt>Frist</dt>
              <dd>{{ task.deadline | date: 'dd.MM.yyyy' }}</dd>
            }
            @if (context.isExternal() && task.contractorName) {
              <dt>Dienstleister</dt>
              <dd data-cy="qr-repair-task-contractor">{{ task.contractorName }}</dd>
            }
            @if (task.creatorTenantName) {
              <dt>Auftraggeber</dt>
              <dd>{{ task.creatorTenantName }}</dd>
            }
            @if (task.description) {
              <dt>Beschreibung</dt>
              <dd class="multiline">{{ task.description }}</dd>
            }
          </dl>

          @if (task.inspectionEntryAttachments.length > 0) {
            <wr-attachments-carousel [attachments]="task.inspectionEntryAttachments"></wr-attachments-carousel>
          }

          <div class="task-actions">
            <button nbButton size="small" status="primary"
                    data-cy="qr-repair-task-finish"
                    (click)="close(task, 'finish')">
              <nb-icon icon="checkmark-outline" pack="eva"></nb-icon>
              Abschließen
            </button>
            <button nbButton size="small" status="danger" outline
                    data-cy="qr-repair-task-decline"
                    (click)="close(task, 'decline')">
              <nb-icon icon="close-outline" pack="eva"></nb-icon>
              Stornieren
            </button>
          </div>
        </article>
      } @empty {
        <div class="empty-state" data-cy="qr-repair-task-empty">
          <nb-icon icon="checkmark-circle-2-outline" pack="eva"></nb-icon>
          <p>Keine offenen Reparaturaufträge</p>
        </div>
      }
    </div>
  } @else {
    <div class="loading-state">
      <nb-spinner status="primary"></nb-spinner>
    </div>
  }

</div>
